import { useSelector } from 'react-redux';

import { selectWorkorderHighestRiskOptions } from '../services/selectors';

export const useWorkorderHighestRiskOptions = () => useSelector(selectWorkorderHighestRiskOptions);
